// Environment Detection Utilities

export const isDevelopment = (): boolean => {
  // Check if we're in a browser environment
  if (typeof window !== 'undefined') {
    // Browser environment - check multiple indicators for development mode
    return (
      import.meta.env.DEV || // Vite development mode
      import.meta.env['VITE_DEV_MODE'] === 'true' || // Explicit dev mode flag
      import.meta.env.MODE === 'development' || // Vite mode
      window.location.hostname === 'localhost' || // Local development
      window.location.hostname === '127.0.0.1' || // Local development
      window.location.hostname.includes('localhost') || // Any localhost variant
      window.location.port === '5173' || // Vite default dev port
      window.location.port === '3000' || // Common dev port
      window.location.protocol === 'http:' // Non-HTTPS (dev indicator)
    );
  } else {
    // Node.js environment - assume development for scripts
    return process.env['NODE_ENV'] !== 'production';
  }
};

export const isProduction = (): boolean => {
  return !isDevelopment();
};

export const getEnvironment = (): 'development' | 'production' => {
  return isDevelopment() ? 'development' : 'production';
};

// Development-specific utilities
export const devUtils = {
  isDevelopment,
  isProduction,
  getEnvironment,

  // Log development info
  logEnvironmentInfo: () => {
    if (isDevelopment()) {
      // Intentionally left side-effect free; call-sites can decide what to display.
      const mode = import.meta.env.MODE;
      void mode;
    }
  }
};
